import { inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ConfigurationData } from '@interfaces';
import { FuncService, TrimesterService } from '../../services';


@Injectable({ providedIn: 'root' })
export class ConfigurationAreaService {

	private func = inject(FuncService);
	private trimesterService = inject(TrimesterService);
	public configurationData = signal<ConfigurationData | undefined>(undefined);

	constructor() {
		toObservable(this.trimesterService.selectedTrimester).subscribe(selectedTrimester => {
			if (selectedTrimester) {
				this.loadConfigurationData();
			}
		})
	}

	// To be called in ngOnInit of child pages; loads data only once using a flag
	async getConfigurationData() {
		if (!this.configurationData()) {
			this.loadConfigurationData();
		}
	}

	// to reload the data
	async loadConfigurationData() {
		const trimesterId = this.trimesterService.selectedTrimester()?.trimesterId;
		if (trimesterId) {
			const data = await this.func.configuration.getConfigurationData({ trimesterId });
			this.configurationData.set(data);
		}
	}

}